var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("title-component"),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col home-card jumbotron-slide-show" },
          [_c("jumbotron-component")],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-12 col-sm-6 home-card" },
          [
            _c("home-title-component", {
              attrs: { title: _vm.$t("home.profile.title") }
            }),
            _vm._v(" "),
            _c("home-content-component", {
              attrs: { content: _vm.$t("home.profile.content") }
            }),
            _vm._v(" "),
            _c("home-link-component", {
              attrs: { path: _vm.homeConfig[0].path }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-12 col-sm-6 home-card" },
          [
            _c("home-title-component", {
              attrs: { title: _vm.$t("home.guardian.title") }
            }),
            _vm._v(" "),
            _c("home-content-component", {
              attrs: { content: _vm.$t("home.guardian.content") }
            }),
            _vm._v(" "),
            _c("home-link-component", {
              attrs: { path: _vm.homeConfig[2].path }
            })
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-12 col-sm-6 home-card" },
          [
            _c("home-title-component", {
              attrs: { title: _vm.$t("home.photos.title") }
            }),
            _vm._v(" "),
            _c("home-content-component", {
              attrs: { content: _vm.$t("home.photos.content") }
            }),
            _vm._v(" "),
            _c("home-link-component", {
              attrs: { path: _vm.homeConfig[4].path }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-12 col-sm-6 home-card" },
          [
            _c("home-title-component", {
              attrs: { title: _vm.$t("home.documents.title") }
            }),
            _vm._v(" "),
            _c("home-content-component", {
              attrs: { content: _vm.$t("home.documents.content") }
            }),
            _vm._v(" "),
            _c("home-link-component", {
              attrs: { path: _vm.homeConfig[5].path }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "col-12 col-sm-6" })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-12 col-sm-6 home-card" },
          [
            _c("home-title-component", {
              attrs: { title: _vm.$t("home.misc.title") }
            }),
            _vm._v(" "),
            _c("home-content-component", {
              attrs: { content: _vm.$t("home.misc.content") }
            }),
            _vm._v(" "),
            _c("home-link-component", {
              attrs: { path: _vm.homeConfig[3].path }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-12 col-sm-6 home-card" },
          [
            _c("home-title-component", {
              attrs: { title: _vm.$t("home.pets.title") }
            }),
            _vm._v(" "),
            _c("home-content-component", {
              attrs: { content: _vm.$t("home.pets.content") }
            }),
            _vm._v(" "),
            _c("home-link-component", {
              attrs: { path: _vm.homeConfig[6].path }
            })
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-12 col-sm-6 home-card" },
          [
            _c("home-title-component", {
              attrs: { title: _vm.$t("home.funeral.title") }
            }),
            _vm._v(" "),
            _c("home-content-component", {
              attrs: { content: _vm.$t("home.funeral.content") }
            }),
            _vm._v(" "),
            _c("home-link-component", {
              attrs: { path: _vm.homeConfig[1].path }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "col-12 col-sm-6" })
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-27cdb7de", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-27cdb7de","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/HomeComponent.vue
// module id = null
// module chunks = 